import React from "react";
import { Modal } from 'react-bootstrap';
import './SendingTokensModal.css'

const SendingTokensModal = (props) => {


    return (
        <>
            <Modal
                show={props.sendingTokens}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    <div className="container text-center">
                        <div className="spinner-border text-warning spinner-padder" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                        <div className="spinner-padder">Sending Charry...</div>
                        <div className="spinner-padder"><em>**Do NOT go back or press refresh. This may take several minutes....</em></div>
                    </div>
                </Modal.Body>
            </Modal>

        </>
    )

}


export default SendingTokensModal;